import {FC} from "react";
import {useMarketItemContext} from "./context";
import classNames from "classnames";

interface MarketItemDescriptionProps {
    className?: string;
}

const MarketItemDescription: FC<MarketItemDescriptionProps> = ({className, ...props}) => {
    const item = useMarketItemContext();
    if (!item?.description) {
        return null;
    }

    return (
        <div className={classNames("ql-container ql-editor", className)}
            dangerouslySetInnerHTML={{ __html: item.description }}
            {...props} />
    )
}

export default MarketItemDescription;